import { atom } from "nanostores";

// Store for current context key
export const $contextKey = atom<string>("");

// Store for previous context key to track changes
export const $previousContextKey = atom<string | undefined>(undefined);

export const contextKeyActions = {
  setContextKey: (contextKey: string) => {
    const currentKey = $contextKey.get();

    // Update previous context key before setting new one
    if (currentKey !== contextKey) {
      $previousContextKey.set(currentKey || undefined);
      $contextKey.set(contextKey);
    }
  },

  resetPreviousContextKey: () => {
    $previousContextKey.set($contextKey.get());
  },

  clear: () => {
    $previousContextKey.set(undefined);
    $contextKey.set("");
  },
};
